module.exports = __webpack_public_path__ + "img/website_leittechnik.ed5f3ad0.jpg";